import React from 'react';
import { Badge } from 'react-bootstrap';
import type { ScanState } from '@/api/sharepointInventoryApi';

const VARIANTS: Record<ScanState, string> = {
  Current: 'success',
  Stale: 'warning',
  Running: 'info',
  Failed: 'danger',
  NeverScanned: 'secondary',
};

const LABELS: Record<ScanState, string> = {
  Current: 'Scanned',
  Stale: 'Stale',
  Running: 'Scanning',
  Failed: 'Failed',
  NeverScanned: 'Never scanned',
};

const ScanStateBadge: React.FC<{ state: ScanState }> = ({ state }) => (
  <Badge bg={VARIANTS[state] ?? 'secondary'}>{LABELS[state] ?? state}</Badge>
);

export default ScanStateBadge;
